import { Box, Button, Container, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';

export default function FreeTrialBanner() {
    const theme = useTheme();

    return (
        <Box
            sx={{
                py: { xs: 8, md: 10 },
                background: 'white',
            }}
        >
            <Container maxWidth="lg">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true }}
                >
                    <Box
                        sx={{
                            p: { xs: 4, md: 5 },
                            background: theme.palette.grey[50],
                            borderRadius: '12px',
                            border: `1px solid ${theme.palette.grey[100]}`,
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            variant="h3"
                            component="h3"
                            sx={{
                                fontSize: { xs: '1.75rem', md: '2.25rem' },
                                fontWeight: 700,
                                mb: 2,
                                color: theme.palette.text.primary,
                            }}
                        >
                            3 Gün Ücretsiz Deneme
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', md: '1.125rem' },
                                mb: 4,
                                fontWeight: 400,
                                color: theme.palette.text.secondary,
                                maxWidth: '600px',
                                mx: 'auto',
                            }}
                        >
                            Helpigo'yu risk almadan deneyin! Hiçbir ödeme yapmadan 3 gün boyunca tüm özelliklerden yararlanın.
                        </Typography>

                        <Button
                            variant="contained"
                            size="large"
                            data-tally-open="wMV9kA"
                            data-tally-layout="modal"
                            data-tally-width="400"
                            data-tally-auto-close="0"
                            sx={{
                                backgroundColor: theme.palette.accent?.main || '#635BFF',
                                color: 'white',
                                py: { xs: 1.75, md: 2.25 },
                                px: { xs: 4, md: 5 },
                                fontSize: { xs: '1rem', md: '1.125rem' },
                                fontWeight: 600,
                                borderRadius: '8px',
                                boxShadow: '0 4px 6px rgba(37, 99, 235, 0.2)',
                                '&:hover': {
                                    backgroundColor: theme.palette.accent?.dark || '#1d4ed8',
                                    boxShadow: '0 10px 15px rgba(37, 99, 235, 0.28)',
                                    transform: 'translateY(-2px)',
                                },
                                transition: 'all 0.2s ease',
                            }}
                        >
                            Demo Kurulumu Talep Et
                        </Button>

                        <Typography
                            variant="body2"
                            sx={{
                                mt: 3,
                                fontSize: { xs: '0.875rem', md: '0.9375rem' },
                                color: theme.palette.text.secondary,
                            }}
                        >
                            Kurulum sadece 5 dakika • Kredi kartı gerekmez • İstediğiniz zaman iptal edebilirsiniz
                        </Typography>
                    </Box>
                </motion.div>
            </Container>
        </Box>
    );
} 